
import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useABTest } from '../hooks/useABTest';

const Hero: React.FC = () => {
  const { group } = useABTest();
  const { scrollY } = useScroll();
  const opacity = useTransform(scrollY, [0, 400], [1, 0]);
  const scale = useTransform(scrollY, [0, 400], [1, 0.95]);
  const imgOpacity = useTransform(scrollY, [200, 600], [0, 1]);
  const imgScale = useTransform(scrollY, [200, 600], [0.8, 1]);

  // Direct link for the requested Google Drive Hero image asset
  const HERO_IMAGE_URL = "https://lh3.googleusercontent.com/d/1HkNMt3GNLWn4CQVzEXwsM72znSyBYiW2";

  return (
    <section className="relative min-h-[160vh] flex flex-col items-center pt-32 px-6">
      {/* Sticky Header Text */}
      <motion.div 
        style={{ opacity, scale }}
        className="sticky top-40 z-10 text-center max-w-4xl"
      >
        <p className="text-[#FFC222] font-bold tracking-widest uppercase mb-4 text-sm md:text-base">
          차별화된 문제 해결 역량의 성장
        </p>
        <h1 className="text-4xl md:text-7xl font-black mb-6 leading-tight">
          {group === 'B' ? (
            <>대학생 연합 창업 동아리,<br /></>
          ) : (
            <>소셜 벤처 창업의 시작,<br /></>
          )}
          <span className="text-[#FFC222]">ENACTUS YM.</span>
        </h1>
        <p className="text-zinc-400 text-lg md:text-xl font-medium max-w-2xl mx-auto">
          1년간의 프로젝트를 통해 문제 해결 역량과 <br className="hidden md:block" /> 실질적인 성과를 함께 만듭니다.
        </p>
      </motion.div>

      {/* Floating Image / Visual Space */}
      <div className="w-full max-w-6xl mt-[40vh]">
        <motion.div 
          style={{ opacity: imgOpacity, scale: imgScale }}
          className="relative rounded-3xl overflow-hidden aspect-[16/9] shadow-2xl shadow-[#FFC222]/10"
        >
          <img 
            src={HERO_IMAGE_URL} 
            alt="Entrepreneurship Work" 
            className="w-full h-full object-cover grayscale brightness-50"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60"></div>
          
          <div className="absolute bottom-8 left-8 md:bottom-12 md:left-12 max-w-lg">
            <div className="flex items-center gap-3 mb-4">
               <div className="w-12 h-1 bg-[#FFC222]"></div>
               <span className="font-bold text-sm tracking-widest">REAL IMPACT</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold">비즈니스로 세상을 바꾸는<br />실전 창업 동아리</h3>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
